/*
 * 转换日期 转换格式可按照年月日时分秒配置 YYYY-MM-DD HH:mm:ss
 * formatDate('2019.11.11 11:11:20', 'YYYY-MM-DD HH:mm:ss'); //"2019-11-11 11:11:20"
 * formatDate('2019-11-11'); // 2019-11-11
 */
const formatDate = (date, template = 'YYYY-MM-DD', blankValue = '-') => {
  if (!date) {
    return blankValue;
  }
  const specs = 'YYYY:MM:DD:HH:mm:ss'.split(':');
  // eslint-disable-next-line no-mixed-operators
  const timeStamp = new Date(date).getTime() - new Date().getTimezoneOffset() * 6e4;
  const res = new Date(timeStamp);
  return res
    .toISOString()
    .split(/[-:.TZ]/)
    .reduce((acc, item, i) => acc.split(specs[i]).join(item), template);
};
const formatTime = (date, blankValue) => formatDate(date, 'YYYY-MM-DD HH:mm:ss', blankValue);
const formatDiagonal = (date, blankValue = '/') => formatDate(date, 'YYYY/MM/DD', blankValue);
const formatYmTime = (date, blankValue = '-') => {
  if (!date) {
    return blankValue;
  }
  const res = new Date(date);
  const Y = `${res.getFullYear()}年`;
  const M = `${res.getMonth() + 1}月`;
  return Y + M;
};
const formatToM = (date, blankValue) => formatDate(date, 'YYYY-MM-DD HH:mm', blankValue);
const formatHMS = (date, blankValue) => formatTime(date, blankValue).slice(-8);
const formatYm = (date, blankValue) => formatYmTime(date, blankValue);

const showtime = (time) => {
  const date =
    typeof time === 'number'
      ? new Date(time)
      : new Date((time || '').replace(/-/g, '/'));
  const diff = (new Date().getTime() - date.getTime()) / 1000;
  const dayDiff = Math.floor(diff / 86400);

  const isValidDate =
    Object.prototype.toString.call(date) === '[object Date]' &&
    !isNaN(date.getTime());

  if (!isValidDate) {
    window.console.error('不是有效日期格式');
  }
  const tempFormatDate = (temDate) => {
    const today = new Date(temDate);
    const year = today.getFullYear();
    const month = (`0${today.getMonth() + 1}`).slice(-2);
    const day = (`0${today.getDate()}`).slice(-2);
    const hour = today.getHours();
    const minute = today.getMinutes();
    const second = today.getSeconds();
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  };
  // 小于0或者大于等于31显示原时间
  if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {
    return tempFormatDate(date);
  }
  return (
    (dayDiff === 0 &&
      ((diff < 60 && '刚刚') ||
        (diff < 120 && '1分钟前') ||
        (diff < 3600 && `${Math.floor(diff / 60)}分钟前`) ||
        (diff < 7200 && '1小时前') ||
        (diff < 86400 && `${Math.floor(diff / 3600)}小时前`))) ||
    (dayDiff === 1 && '昨天') ||
    (dayDiff < 7 && `${dayDiff}天前`) ||
    (dayDiff < 31 && `${Math.ceil(dayDiff / 7)}周前`)
  );
};
export default {
  formatDate,
  formatTime,
  formatToM,
  formatHMS,
  formatYm,
  formatDiagonal,
  showtime
};



// WEBPACK FOOTER //
// ./src/utils/format-time.js